"use strict";

var _classCallCheck = require("/Users/bhautik/Project/macrometa/demo-crypto-trading-5g/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/bhautik/Project/macrometa/demo-crypto-trading-5g/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = require("./error");

exports.USER_NOT_FOUND = 1703;

var User = /*#__PURE__*/function () {
  function User(connection, user) {
    var email = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    _classCallCheck(this, User);

    this.user = "";
    this.urlPrefix = "/_admin/user";
    this.user = user;
    this._connection = connection;
    this.email = email;
  }

  _createClass(User, [{
    key: "createUser",
    value: function createUser() {
      var passwd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._connection.request({
        method: "POST",
        path: this.urlPrefix,
        body: {
          user: this.user,
          email: this.email,
          passwd: passwd,
          active: active,
          extra: extra
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getUserDeatils",
    value: function getUserDeatils() {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix, "/").concat(this.user)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "hasUser",
    value: function hasUser() {
      return this.getUserDeatils().then(function () {
        return true;
      }, function (err) {
        if (error_1.isC8Error(err) && err.errorNum === exports.USER_NOT_FOUND) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "deleteUser",
    value: function deleteUser() {
      return this._connection.request({
        method: "DELETE",
        path: "".concat(this.urlPrefix, "/").concat(this.user)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "_makeModification",
    value: function _makeModification(config, methodType) {
      return this._connection.request({
        method: methodType,
        path: "".concat(this.urlPrefix, "/").concat(this.user),
        body: Object.assign({}, config)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "modifyUser",
    value: function modifyUser(config) {
      return this._makeModification(config, "PATCH");
    }
  }, {
    key: "replaceUser",
    value: function replaceUser(config) {
      return this._makeModification(config, "PUT");
    }
  }, {
    key: "getAllDatabases",
    value: function getAllDatabases() {
      var isFullRequested = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database"),
        qs: {
          full: isFullRequested
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getDatabaseAccessLevel",
    value: function getDatabaseAccessLevel(databaseName) {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(databaseName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearDatabaseAccessLevel",
    value: function clearDatabaseAccessLevel(fabricName) {
      return this._connection.request({
        method: "DELETE",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(fabricName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setDatabaseAccessLevel",
    value: function setDatabaseAccessLevel(fabricName, permission) {
      return this._connection.request({
        method: "PUT",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(fabricName),
        body: {
          grant: permission
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getCollectionAccessLevel",
    value: function getCollectionAccessLevel(databaseName, collectionName) {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(databaseName, "/collection/").concat(collectionName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearCollectionAccessLevel",
    value: function clearCollectionAccessLevel(fabricName, collectionName) {
      return this._connection.request({
        method: "DELETE",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(fabricName, "/collection/").concat(collectionName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setCollectionAccessLevel",
    value: function setCollectionAccessLevel(fabricName, collectionName, permission) {
      return this._connection.request({
        method: "PUT",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(fabricName, "/collection/").concat(collectionName),
        body: {
          grant: permission
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "listAvailableUsers",
    value: function listAvailableUsers() {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getStreamAccessLevel",
    value: function getStreamAccessLevel(databaseName, streamName) {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(databaseName, "/stream/").concat(streamName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearStreamAccessLevel",
    value: function clearStreamAccessLevel(databaseName, streamName) {
      return this._connection.request({
        method: "DELETE",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(databaseName, "/stream/").concat(streamName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setStreamAccessLevel",
    value: function setStreamAccessLevel(databaseName, streamName, permission) {
      return this._connection.request({
        method: "PUT",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(databaseName, "/stream/").concat(streamName),
        body: {
          grant: permission
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "listAccessibleCollections",
    value: function listAccessibleCollections(databaseName) {
      var isFullRequested = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(databaseName, "/collection"),
        qs: {
          full: isFullRequested
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "listAccessibleStreams",
    value: function listAccessibleStreams(databaseName) {
      var isFullRequested = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/database/").concat(databaseName, "/stream"),
        qs: {
          full: isFullRequested
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getBillingAccessLevel",
    value: function getBillingAccessLevel() {
      return this._connection.request({
        method: "GET",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/billing")
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearBillingAccessLevel",
    value: function clearBillingAccessLevel() {
      return this._connection.request({
        method: "DELETE",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/billing")
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setBillingAccessLevel",
    value: function setBillingAccessLevel(permission) {
      return this._connection.request({
        method: "PUT",
        path: "".concat(this.urlPrefix, "/").concat(this.user, "/billing"),
        body: {
          grant: permission
        }
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return User;
}();

exports.default = User;